 import { useState, useRef, useEffect } from 'react';
 import PropTypes from 'prop-types';

const MultiSelect = ({data, variables, pholder, setreturn, seleccionado, className}) => {
    
  const [abierto, setAbierto] = useState(false);
  const [seleccionados, setSeleccionados] = useState([]);
  const refContenedor = useRef(null);
  const prevReturn = useRef([])

  const toggleOpcion = (id) => {
    setSeleccionados((prev) => {
    const actualizado = prev.includes(id) 
      ? prev.filter((item) => item !== id) 
      : [...prev, id];
      return actualizado
    });
    
  };
  //-----------------------------------------------------------------------
  const cerrarSiClickFuera = (e) => {
    if (refContenedor.current && !refContenedor.current.contains(e.target)) {
      setAbierto(false);
    }
  };
  //-----------------------------------------------------------------------
  useEffect(() => {
    document.addEventListener('mousedown', cerrarSiClickFuera);
    return () => document.removeEventListener('mousedown', cerrarSiClickFuera);
  }, []);

  useEffect(() => {
  if (typeof setreturn === 'function') {
    const diferentes = JSON.stringify(prevReturn.current) !== JSON.stringify(seleccionados);
    if (diferentes) {
      prevReturn.current = seleccionados;
      setreturn(seleccionados);
    }
  }
}, [seleccionados]);

useEffect(() => 
  {
     if (Array.isArray(seleccionado)) 
      {
         const diferentes = JSON.stringify(seleccionados) !== JSON.stringify(seleccionado);
         if (diferentes) 
          {
            setSeleccionados(seleccionado);
         }
     }
}, [seleccionado]);


return (
    <div className="relative w-full " ref={refContenedor}>
      <input
          type="text"
          readOnly
          value={
                seleccionados.length > 0
                ? data
                  .filter((opt) => seleccionados.includes(opt[variables[0]]))
                  .map((opt) => opt[variables[1]])
                  .join(', ')
                : ''
              }
          onClick={() => setAbierto((prev) => !prev)}
          placeholder={pholder && pholder!==''? pholder :"Selecciona opciones"}
          className={`multiselec ${className}`}
         // onMouseDown={(e) => e.preventDefault()} // evita que pierda el focus
      />
       <svg
           className="w-4 h-4 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
           fill="none"
           stroke="currentColor"
           strokeWidth="2"
          viewBox="0 0 24 24"
        >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
       </svg>

      {abierto && (
  
        <div className="absolute z-10 mt-1 w-full border rounded bg-white shadow max-h-60 overflow-y-auto">
          {data.map((opcion, index) => (
            <label
              key={index}
              className="flex items-center px-4 pt-[0.28rem] hover:bg-gray-100 cursor-pointer"
            >
              <input
                type="checkbox"
                key={index}
                checked={seleccionados.includes(opcion[variables[0]])}
                onChange={() => toggleOpcion(opcion[variables[0]])}
                className="mr-2"
              />
              {opcion[variables[1]]}
            </label>
          
          ))}
          </div>  
        )      }
    </div>
  );
};
MultiSelect.propTypes = {
  data: PropTypes.array.isRequired,
  variables: PropTypes.array.isRequired,
  pholder:PropTypes.string,
  setreturn: PropTypes.func.isRequired,
  seleccionado: PropTypes.array.isRequired,
  className: PropTypes.string  
};

export default MultiSelect;
